export default __webpack_public_path__ + "static/media/logo-color.b7f4d7c6.png";